// extracted by mini-css-extract-plugin
module.exports = {"landing":"landing-module--landing--1CyRu","title":"landing-module--title--3QcnM","subtitle":"landing-module--subtitle--1Fjk-"};